export default function Loading(){
    return (
        <div className="main-container">
          <div className="loader flex items-center justify-center">
            <div className="wrapper w-[180px] h-[50px] relative flex items-center justify-center z-20">
              <div className="text z-30 font-[Whitney,apple-system,Helvetica] tracking-[1px] font-bold text-[20px] text-white drop-shadow-[2px_2px_0px_#ff9e02]">
                Loading...
              </div>
              <div className="box w-full h-full bg-[#ef5d2e] absolute z-20 flex items-center justify-center animate-loading">
                <div className="absolute w-[20px] h-[170%] bg-[#ff9d0089] z-10 animate-loading2"></div>
              </div>
            </div>
          </div>
        </div>
    );
}